<template>
    <div>
        <el-table
            :data="tableData"
            :cell-style="cellStyling"
            style="width: 100%"
            :row-class-name="endpoint.includes('total') ? 'totalRow' : ''"
            :cell-class-name="cellStyle"
            :header-cell-class-name="cellStyle">
            <el-table-column  v-for="col in getHeaders"
                              :key="col"
                              :prop="col"
                              :label="col | formatVariableName"
                              :sortable="endpoint.includes('total') ? false : true"
                              :formatter="formatter"
                              class="border-right"
            >
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import axios from '@/services/axios.js'
import { getNumberOfWeek, getHeadersWithAccessToken, breakPoints } from '../../functions.js'

export default {
    props: ['title', 'endpoint'],
    data () {
        return {
            tableData: [],
            tableHeaders: [],
            totalRow: {},
            kpiHeaders: ['kpu', 'ctr', 'prod'],
            columnMapping: {
                'store': 'all',
                'week': 'all',
                'hours_actual': 'all',
                'hours_budget': 'xs',
                'hours_index': 'md',
                'hours_ly': 'md',
                'rev_ly': 'md',
                'rev_actual': 'all',
                'rev_budget': 'xs',
                'rev_index': 'md',
                'score': 'lg',
                'prod': 'lg',
                'kpu': 'xl',
                'ctr': 'xl'
            }
        }
    },
    computed: {
        getHeaders () {
            if (this.tableHeaders.length === 0) {
                return []
            } else {
                if (this.columnMapping !== undefined && Object.keys(this.columnMapping).length > 0) {
                    let h = []
                    for (let col of this.tableHeaders) {
                        if (breakPoints[this.columnMapping[col]] < this.$store.state.general.windowWidth) {
                            h.push(col)
                        }
                    }
                    return h
                } else {
                    return this.tableHeaders
                }
            }
        }
    },
    methods: {
        update () {
            console.log(this.$store.state.graphFilter.performancePeriod['begin'])
            axios.post(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_DATA_API_BASE_URL_DEV : process.env.VUE_APP_DATA_API_BASE_URL) + '/at' + this.$props.endpoint, {
                'format': 'aod',
                'store_id': this.$store.getters['graphFilter/getStoreIds'],
                'begin_week': getNumberOfWeek(this.$store.state.graphFilter.performancePeriod['begin']),
                'end_week': getNumberOfWeek(this.$store.state.graphFilter.performancePeriod['end']),
                'begin_year': this.$store.state.graphFilter.performancePeriod['begin'].getFullYear(),
                'end_year': this.$store.state.graphFilter.performancePeriod['end'].getFullYear(),
                'days_back': 0
            }, { headers: getHeadersWithAccessToken() })
                .then(response => {
                    this.tableData = response.data.data
                    // Set data for export
                    if (this.endpoint.includes('total')) {
                        this.$store.commit('budget/SET_ANALYTICS_TABLE', { data: response.data.data, total: true })
                    } else {
                        this.$store.commit('budget/SET_ANALYTICS_TABLE', { data: response.data.data, total: false })
                    }
                    if (this.$store.state.graphFilter.performanceKPI === 'KPI') {
                        this.tableHeaders = response.data.columns
                    } else {
                        this.tableHeaders = []
                        for (let col of response.data.columns) {
                            let idx = this.kpiHeaders.indexOf(col)
                            if (idx === -1) {
                                this.tableHeaders.push(col)
                            }
                        }
                    }
                    this.$emit('dataLoaded')
                })
                .catch(error => {
                    console.log(error)
                    this.$emit('dataLoaded')
                })
        },
        formatter (row, column) {
            if (row[column.property] !== null) {
                if ((column.property.split('_')[0] === 'rev' && column.property.split('_')[1] !== 'index') || column.property === 'kpu' || column.property === 'prod') {
                    return '€' + row[column.property].toLocaleString('en-EN')
                } else if (column.property.split('_')[0] === 'rev' && column.property.split(' ')[1] === 'index') {
                    return row[column.property]
                } else if (column.property === 'ctr') {
                    return row[column.property].toLocaleString('en-EN') + '%'
                } else {
                    return row[column.property].toLocaleString('en-EN')
                }
            } else {
                return row[column.property]
            }
        },
        getSummaries (param) {
            const { columns } = param
            const total = []
            columns.forEach((column, index) => {
                if (column !== null) {
                    if ((column.property.split('_')[0] === 'rev' && column.label.split(' ')[1] !== 'index') || column.property === 'KPU' || column.property === 'prod') {
                        total[index] = '€' + this.totalRow[column.label].toLocaleString('en-EN')
                    } else if (column.property === 'ctr') {
                        total[index] = this.totalRow[column.label].toLocaleString('en-EN') + '%'
                    } else {
                        total[index] = this.totalRow[column.label].toLocaleString('en-EN')
                    }
                } else {
                    total[index] = null
                }
            })
            return total
        },
        cellStyling (param) {
            const { column, row } = param
            if (column.property === 'score' && row[column.property] !== null) {
                if (row[column.property] < 90) {
                    return { backgroundColor: '#f5c6cb' }
                } else if (row[column.property] >= 110) {
                    return { backgroundColor: '#c3e6cb' }
                } else {
                    return { backgroundColor: 'rgba(0,0,0,.075)' }
                }
            }
        },
        cellStyle (param) {
            const { column } = param
            if (column.property === 'prod' || column.property === 'rev_actual' || column.property === 'score') {
                return 'borderLeftRow'
            }
        }
    },
    created () {
        this.update()
    }
}
</script>

<style lang="scss">
.totalRow {
    background-color: #f5f7fa !important;
}
.borderLeftRow {
    border-left: 1px solid #EBEEF5;
}
</style>
